module.exports = __webpack_public_path__ + "pic/22.a296bf3f.png";